import { useState, useEffect } from 'react'
import Greeting from 'components/Dashboard/Greeting'
import NeedsAttention from 'components/Dashboard/NeedsAttention'
import UpcomingAppointments from 'components/Dashboard/UpcomingAppointments'
import Profile from 'components/Dashboard/Profile'
import { ProfileSkeleton, VisitsSkeleton } from 'components/Dashboard/Skeleton'
import ConfirmAppointmentModal from 'components/Appointment/ConfirmAppointmentModal'
import AppointmentModal from 'components/Appointment/AppointmentModal'
import { AppointmentActions, DashboardActions, ProfileActions } from 'store/actions'
import { mapAppointment } from 'store/Appointments/helper'
import { getPractice } from 'library/auth'
import { connect } from 'react-redux'
import toast from 'react-hot-toast'


let enhancer = connect(null, { ...DashboardActions, ...AppointmentActions, ...ProfileActions })

const Dashboard = ({ showDashboard, showProfile, updateAppointment }) => {
  const [dashboardata, setDashboardData] = useState(null)
  const [profile, setProfile] = useState(null)
  const [toConfirm, setToConfirm] = useState(null)
  const [confirming, setConfirming] = useState(false)

  const { upcoming_appointments, needs_attention = [] } = dashboardata?.attributes || {}
  const appointments = (upcoming_appointments?.data || []).map(({ attributes }) => mapAppointment(attributes))
  const formsAccess = Boolean(getPractice()?.patient_forms_access)

  const loadDashboard = async () => {
    try {
      const { data } = await showDashboard()
      setDashboardData(data)
    } catch (error: any) {
      toast.error(error.errors || 'Failed to load dashboard. Please try again later.')
    }
  }

  const loadProfile = async () => {
    try {
      const { data } = await showProfile()
      setProfile(data)
    } catch (error: any) {
      toast.error(error.errors || 'Failed to load profile. Please try again later.')
    }
  }

  const closeConfirmAppointmentModal = () => {
    if (confirming) return

    setToConfirm(null)
    loadDashboard()
    loadProfile()
  }

  const confirmAppointment = async () => {
    setConfirming(true)

    try {
      await updateAppointment(toConfirm.id, 'confirm')
    } catch (error: any) {
      toast.error(error.errors || 'Failed to confirm appointment. Please try again later.')
      throw error
    } finally {
      setConfirming(false)
    }
  }

  useEffect(() => {
    loadDashboard()
    loadProfile()
  }, [])

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-start lg:flex-1 lg:min-h-0 lg:contain-size lg:grid-rows-[minmax(0,1fr)]">
      <div className="flex flex-col gap-4 lg:col-span-2 lg:min-h-0 lg:self-stretch">
        <Greeting />

        {dashboardata ? (
          <>
            <NeedsAttention items={needs_attention} onConfirm={setToConfirm} />

            <UpcomingAppointments appointments={appointments} />
          </>
        ) : (
          <VisitsSkeleton />
        )}
      </div>

      <div className="space-y-4 lg:min-h-0 lg:self-stretch lg:overflow-y-auto lg:overscroll-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {profile ? <Profile profile={profile} onRefresh={loadProfile} /> : <ProfileSkeleton />}
      </div>

      {formsAccess ? (
        <ConfirmAppointmentModal
          open={Boolean(toConfirm)}
          appointment={toConfirm}
          profile={profile}
          loading={confirming}
          onClose={closeConfirmAppointmentModal}
          onConfirm={confirmAppointment}
        />
      ) : (
        <AppointmentModal
          open={Boolean(toConfirm)}
          loading={confirming}
          onClose={closeConfirmAppointmentModal}
          onConfirm={confirmAppointment}
        />
      )}
    </div>
  )
}

export default enhancer(Dashboard);
